import _Form from './Form';

import './style/index.js';

export type { FormProps } from './Form';
export type { FormItemProps } from './FormItem';
export * from './type';
export * from './hooks/interface';

export const Form = _Form;
export default Form;
